import _toConsumableArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { StartEllipsis, EndEllipsis } from './Pagination.types';
/**
 * Returns an array of pages with truncated start and end depending
 * on the currently selected page.
 * @param {number} page Currently selected item
 * @param {number} count Total amount of items
 * @returns {PaginationItem[]}
 */

export function getExtendedPages(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages;
  var pages = Array.from({
    length: totalPages
  }, function (_, i) {
    return i + 1;
  }); // no action for less than 7 items

  if (totalPages <= 6) return pages; // first and last chunks can be either 1 or 5 pages

  var firstPage = 1;
  var firstPages = pages.slice(0, 5);
  var lastPage = totalPages;
  var lastPages = pages.slice(lastPage - 5, lastPage); // show pages first to fifth if selected is first to fourth,
  // show first otherwise

  var startSegment = currentPage <= 4 ? firstPages : [firstPage];
  var truncateFirst = currentPage > 4;
  var middleSegment = currentPage > 4 && currentPage < lastPage - 3 ? pages.slice(currentPage - 2, currentPage + 1) : [null];
  var truncateLast = currentPage < lastPage - 3 || totalPages === 7 && currentPage < lastPage - 2; // show pages 5th to last to last if selected 4th to last to last is one of them,
  // show last otherwise

  var endSegment = currentPage > lastPage - 4 ? totalPages === 7 && currentPage < lastPage - 2 ? [lastPage] : lastPages : [lastPage];
  pages = [].concat(_toConsumableArray(startSegment), [truncateFirst ? StartEllipsis : null], _toConsumableArray(middleSegment), [truncateLast ? EndEllipsis : null], _toConsumableArray(endSegment)).filter(function (page) {
    return page !== null;
  });
  return pages;
}